// import { lazy } from 'react';
import { AppProvider } from './context/AppContext';
import { Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ChatScreen from './pages/Chat';
import Login from './pages/Authencation/Login';
import ProtectedRoute from './component/ProtectedRoute';
import UnAuthenRoute from './component/UnAuthenRoute';
import Register from './pages/Authencation/Register';
import ForgotPassword from './pages/Authencation/ForgotPassword';
import MainLogin from './pages/Authencation/MainLogin';
import Download from './pages/Download';
function App() {
  return (
    <div
      className="w-screen min-h-screen h-fit"
      style={{ backgroundColor: '#fff' }}
    >
      <AppProvider>
        <Routes>
          <Route
            path="/main-login"
            element={
              <UnAuthenRoute>
                <MainLogin />
              </UnAuthenRoute>
            }
          />
          <Route
            path="/login"
            element={
              <UnAuthenRoute>
                <Login />
              </UnAuthenRoute>
            }
          />
          <Route
            path="/register"
            element={
              <UnAuthenRoute>
                <Register />
              </UnAuthenRoute>
            }
          />
          <Route
            path="/forgot-password"
            element={
              <UnAuthenRoute>
                <ForgotPassword />
              </UnAuthenRoute>
            }
          />
          <Route path="/download" element={<Download />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <ChatScreen />
              </ProtectedRoute>
            }
          />
        </Routes>
        <ToastContainer
          position="top-right"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss={false}
          draggable
          pauseOnHover={false}
          theme="colored"
          style={{
            fontSize: '14px',
            fontWeight: 500,
            zIndex: 9999,
          }}
          toastStyle={{
            maxWidth: '300px',
            minHeight: '50px',
            margin: '10px',
            padding: '10px 15px',
            borderRadius: '12px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            overflow: 'hidden',
            background: 'white',
            color: 'black',
          }}
          icon={false}
        />
      </AppProvider>
    </div>
  );
}

export default App;
